import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { getLocale } from "react-i18nify";
import { useSnackbar } from "notistack";
import * as MatStyled from "@mui/material/styles";

import {
  getSellerDetail,
  approveUpdateSeller,
  rejectUpdateSeller,
  updateSellerByAdmin,
} from "src/api/seller";

import { device } from "src/styles/device";
import { checkNotEmpty, downloadImage } from "src/common";
import { decryptData } from "src/components/profile/DecryptData";
import { useDialog } from "src/context/DialogContext";
import { useAuth } from "src/hooks/useAuth";

import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import { Delete, PhotoCameraOutlined } from "@mui/icons-material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Forbidden from "src/pages/Forbidden";
import ModalFullImage from "src/components/ui/ModalFullImage";
import DropZone from "src/components/core/DropZone";
import StyledButton from "src/components/core/Button";

import AddLocationDialog from "src/components/seller/AddLocationDialog";
import TermsComponent from "src/components/seller/Terms";

const DivHeaderProfile = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;
`;

const WrapperImageRow = styled.div`
  display: flex;
  padding: 16px;
`;

const WrapperImage = styled.div`
  min-width: 120px;
  height: auto;
  object-fit: cover;
  object-position: center;
  margin-right: 16px;
  border-radius: 16px;
`;

const PDownloadPdf = styled.p`
  text-align: center;
  font-size: 0.875rem;

  &:hover {
    color: #e43;
    cursor: pointer;
  }
`;

const WrapperOtherImage = styled.div`
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
  margin-right: 16px;
  border-radius: 16px;
  @media ${device.tabletL} {
    height: 150px;
  }
  @media ${device.mobile} {
    height: 100px;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  position: relative;
  padding: 40px 120px 80px;
  margin: auto;

  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.lcd} {
    padding: 40px 60px 80px;
  }
`;

const DivBackground = styled.div`
  width: 100%;
  padding: 32px;
  background-color: rgb(243, 241, 242);
  box-shadow: rgb(0 0 0 / 16%) 3px 4px 3px;
  border-radius: 30px;
  margin: 16px 0;
`;

const SpanTitle = styled.span`
  color: #000;
  font-size: 1.5rem;
  font-weight: 500;
`;

const SpanHeader = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 16px;
`;

const SpanSubHeader = styled.p`
  color: rgb(106 106 109);
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 16px;
`;

const SpanReject = styled.span`
  color: rgb(194, 43, 29);
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 16px;
`;

const SpanContent = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
`;

const SpanContentDesc = styled.p`
  color: #000;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 16px;
  min-height: 90px;
  max-height: 150px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 5px 1px;
  width: 120px;
  height: 120px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  // cursor: pointer;
  vertical-align: initial;
  margin-right: 16px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;
const WrapperTextField = styled.div`
  margin: 8px;
  width: 98%;
  margin-bottom: 16px;

  .MuiTab-root.Mui-selected {
    background: #f8f8f8;
    color: #e04132;
  }
  .MuiTabs-indicator {
    background-color: #e04132;
  }
  .MuiBox-root {
    border: none;
    background: #f8f8f8;
    border-radius: 16px;
    padding: 0 8px;
  }

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    background: #fff;
    border-radius: 16px;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;
const ImageOtherEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 5px 1px;
  width: 100%;
  height: 220px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  // cursor: pointer;
  vertical-align: initial;
  margin-right: 16px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
  @media ${device.tabletL} {
    height: 150px;
  }
  @media ${device.mobile} {
    height: 100px;
  }
`;

const SpanFullImage = styled.span`
  font-size: 0.625rem;
  margin: 0 0 8px 0;
  display: flex;
  color: #000;
  justify-content: center;
  &:hover {
    cursor: pointer;
    color: #e43;
    text-decoration: underline;
  }
`;

const WrapperTextfield = styled.div`
  width: 100%;
  margin-top: -8px;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: transparent;
  }
  .MuiAutocomplete-root {
    /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    border-radius: 16px;
    padding: 10px 14px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
    padding: 0;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0;
  }
`;

const StyledAccordion = styled(Accordion)`
  border-radius: 30px;
  padding: 16px;

  &.MuiAccordion-root {
    background-color: #f3f1f2;
    box-shadow: rgb(0 0 0 / 16%) 3px 4px 3px;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root.Mui-expanded {
    background-color: #f3f1f2;
    border-radius: 14px;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const SellerDetail = ({ open }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { user, checkAllowPermission } = useAuth();
  let { sellerId } = useParams();
  const navigate = useNavigate();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [isEdit, setIsEdit] = useState(false);
  const [comment, setComment] = useState("");
  const [isRemark, setIsRemark] = useState(false);
  const [sellerData, setSellerData] = useState({});

  useEffect(() => {
    if (sellerId === undefined) return;

    fetchSellerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerId]);

  const fetchSellerData = async () => {
    await getSellerDetail(sellerId)
      .then(async ({ data }) => {
        const decrypt = await decryptData(data);
        // console.log("----- seller -----", decrypt);
        setSellerData({
          ...decrypt,
          profile_image: decrypt?.profile_image || "",
          warehouse_image: decrypt?.warehouse_image || "",
          registation: decrypt?.registation || "",
          banner_image: decrypt?.banner_image || "",
          id_card_image: decrypt?.id_card_image || "",
          book_bank_image: decrypt?.book_bank_image || "",
          work_image_first: decrypt?.work_image_first || "",
          work_image_second: decrypt?.work_image_second || "",
          work_image_third: decrypt?.work_image_third || "",
          work_image_fourth: decrypt?.work_image_fourth || "",
          work_image_fifth: decrypt?.work_image_fifth || "",
          work_image_sixth: decrypt?.work_image_sixth || "",
        });
      })
      .catch((err) => {
        console.log("error", err.message);
        navigate("/404");
      });
  };

  const handleSaveApprove = async () => {
    try {
      let params = {
        id: sellerId,
      };

      await approveUpdateSeller(params);

      enqueueSnackbar(`บันทึกสำเร็จ`, {
        variant: "success",
      });
    } catch (err) {
      console.error(err);
      enqueueSnackbar(`เกิดข้อผิดพลาด บันทึกไม่สำเร็จ`, {
        variant: "error",
      });
    } finally {
      fetchSellerData();
      setIsEdit(false);
    }
  };

  const handleSaveReject = async () => {
    try {
      let params = {
        id: sellerId,
        message: comment,
      };

      await rejectUpdateSeller(params);

      enqueueSnackbar(`ปฏิเสธผู้ขายสำเร็จ`, {
        variant: "success",
      });
    } catch (err) {
      console.error(err);
      enqueueSnackbar(`เกิดข้อผิดพลาด ปฏิเสธผู้ขายไม่สำเร็จ`, {
        variant: "error",
      });
    } finally {
      fetchSellerData();
      setIsEdit(false);
    }
  };

  // const handleUpdateSellerMedia = async () => {
  //   try {
  //     const payload = {
  //       icon_homepage: sellerData?.icon_homepage,
  //       book_bank_image: sellerData?.book_bank_image,
  //     };

  //     await updateSellerMedia(sellerId, payload); // only update category available

  //     enqueueSnackbar(`บันทึกสำเร็จ`, {
  //       variant: "success",
  //     });

  //     fetchSellerData();
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleUpdateSeller = async () => {
    try {
      await updateSellerByAdmin(sellerId, sellerData);

      enqueueSnackbar(`บันทึกสำเร็จ`, {
        variant: "success",
      });
    } catch (err) {
      console.error(err);
    } finally {
      fetchSellerData();
      setIsEdit(false);
    }
  };

  const PartnerType = (type) => {
    if (type === 1) {
      return <> {getLocale() === "th" ? "โรงงาน" : "Manufactory"}</>;
    } else if (type === 2) {
      return <> {getLocale() === "th" ? "เจ้าของร้าน" : "Store owner"}</>;
    } else if (type === 3) {
      return <>{getLocale() === "th" ? "ผู้จัดจำหน่าย" : "Distributor"}</>;
    } else if (type === 4) {
      return <>{getLocale() === "th" ? "ร้านค้าปลีก" : "Retailer"}</>;
    } else {
      return <> {getLocale() === "th" ? "ตัวแทนขาย" : "Sale representative"}</>;
    }
  };

  if (user?.role_id === 3) return <Forbidden />;

  return (
    <Main
      sx={{ width: "100%", marginTop: "75px", background: "#fff" }}
      open={open}
    >
      <Container>
        <DivHeaderProfile>
          <SpanTitle>
            {getLocale() === "th" ? `โปรไฟล์ของผู้ขาย` : "Seller Profile"}
          </SpanTitle>

          {checkAllowPermission("sellers.can_edit") ? (
            <StyledButton
              variant="secondary"
              startIcon={<EditIcon />}
              onClick={() => {
                if (isEdit) {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      setIsEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                } else {
                  setIsEdit(true);
                }
              }}
            >
              {getLocale() === "th" ? "แก้ไขข้อมูล" : "Edit profile"}
            </StyledButton>
          ) : null}
        </DivHeaderProfile>

        <Grid container spacing={4}>
          <Grid item xs={8} sx={{ margin: "0 auto" }}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "บัญชีโปรไฟล์" : "Profile account"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อบริษัท" : "Company name"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={sellerData?.company_name || ""}
                      onChange={(e) =>
                        setSellerData({
                          ...sellerData,
                          company_name: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(sellerData?.company_name)}
                      helperText={
                        !checkNotEmpty(sellerData?.company_name)
                          ? "โปรดระบุชื่อบริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th" ? "เบอร์โทรศัพท์" : "Phone number"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={sellerData?.phone_number || ""}
                      onChange={(e) =>
                        setSellerData({
                          ...sellerData,
                          phone_number: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(sellerData?.phone_number)}
                      helperText={
                        !checkNotEmpty(sellerData?.phone_number)
                          ? "โปรดระบุเบอร์โทรศัพท์"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "อีเมลของคุณ"
                      : "Your email address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sellerData?.email === "" ||
                    sellerData?.email === "null" ||
                    sellerData?.email === null ||
                    sellerData?.email === undefined
                      ? "-"
                      : sellerData?.email}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "ที่อยู่บริษัทของคุณ"
                      : "Your company address"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      value={sellerData?.address || ""}
                      onChange={(e) =>
                        setSellerData({
                          ...sellerData,
                          address: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(sellerData?.address)}
                      helperText={
                        !checkNotEmpty(sellerData?.address)
                          ? "โปรดระบุที่อยู่บริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "เกี่ยวกับบริษัทของคุณ"
                      : "About your company"}
                  </SpanSubHeader>
                  <WrapperTextfield>
                    <TextField
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={3}
                      value={sellerData?.description || ""}
                      onChange={(e) =>
                        setSellerData({
                          ...sellerData,
                          description: e.target.value,
                        })
                      }
                      error={!checkNotEmpty(sellerData?.description)}
                      helperText={
                        !checkNotEmpty(sellerData?.description)
                          ? "โปรดระบุเกี่ยวกับบริษัท"
                          : ""
                      }
                    />
                  </WrapperTextfield>
                </>
              ) : (
                <>
                  <SpanSubHeader>
                    {getLocale() === "th" ? "ชื่อบริษัท" : "Company name"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sellerData?.company_name === "" ||
                    sellerData?.company_name === "null" ||
                    sellerData?.company_name === null
                      ? "-"
                      : sellerData?.company_name}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th" ? "เบอร์โทรศัพท์" : "Phone number"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sellerData?.phone_number === "" ||
                    sellerData?.phone_number === "null" ||
                    sellerData?.phone_number === null
                      ? "-"
                      : sellerData?.phone_number}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "อีเมลของคุณ"
                      : "Your email address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sellerData?.email === "" ||
                    sellerData?.email === "null" ||
                    sellerData?.email === null ||
                    sellerData?.email === undefined
                      ? "-"
                      : sellerData?.email}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "ที่อยู่บริษัทของคุณ"
                      : "Your company address"}
                  </SpanSubHeader>
                  <SpanContent>
                    {sellerData?.address === "" ||
                    sellerData?.address === "null" ||
                    sellerData?.address === null
                      ? "-"
                      : sellerData?.address}
                  </SpanContent>

                  <SpanSubHeader>
                    {getLocale() === "th"
                      ? "เกี่ยวกับบริษัทของคุณ"
                      : "About your company"}
                  </SpanSubHeader>
                  <SpanContentDesc>
                    {sellerData?.description === "" ||
                    sellerData?.description === "null" ||
                    sellerData?.description === null
                      ? "-"
                      : sellerData?.description}
                  </SpanContentDesc>
                </>
              )}

              <SpanSubHeader>
                {getLocale() === "th"
                  ? "ตำแหน่งที่ตั้งบริษัทของคุณ"
                  : "Your company location"}
              </SpanSubHeader>
              <div>
                <StyledButton
                  variant="contained"
                  onClick={() => {
                    openDialog({
                      type: "custom",
                      customDialog: (
                        <AddLocationDialog
                          sellerDetail={sellerData}
                          onClose={() => closeDialog()}
                          onSuccess={() => {
                            closeAllDialogs();
                            fetchSellerData();
                          }}
                        />
                      ),
                    });
                  }}
                >
                  {getLocale() === "th"
                    ? "จัดการตำแหน่งที่ตั้งบริษัท"
                    : "Manage company location"}
                </StyledButton>
              </div>
            </DivBackground>
          </Grid>

          <Grid
            item
            xs={4}
            sx={{
              margin: "0 auto",
              display: "grid",
              gridTemplateRows: "repeat(3, 1fr)",
            }}
          >
            <DivBackground
              style={{ maxWidth: "300px", height: "185px", marginLeft: "auto" }}
            >
              <SpanSubHeader>
                {getLocale() === "th" ? "จำนวนสินค้า" : "Product"}
              </SpanSubHeader>
              <SpanContent>{sellerData?.productCount}</SpanContent>
            </DivBackground>

            <DivBackground
              style={{ maxWidth: "300px", height: "185px", marginLeft: "auto" }}
            >
              <SpanSubHeader>
                {getLocale() === "th" ? "วันที่เข้าร่วม" : "Join On"}
              </SpanSubHeader>
              <SpanContent>
                {moment(sellerData?.createdAt).format("L")}
              </SpanContent>
            </DivBackground>

            <DivBackground
              style={{ maxWidth: "300px", height: "185px", marginLeft: "auto" }}
            >
              <SpanSubHeader>
                {getLocale() === "th" ? "ประเภทธุรกิจ" : "Type of business"}
              </SpanSubHeader>
              <SpanContent>{PartnerType(sellerData?.seller_type)}</SpanContent>
            </DivBackground>
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ margin: "auto" }}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "บัญชีโปรไฟล์" : "Profile account"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <WrapperImageRow>
                    {/* This is just a quick component for uploading icon homepage images, 
                    it should be improved if we have to deal with this again in the future. 
                    tarit Sep 9 2024 */}
                    {!checkNotEmpty(sellerData?.icon_homepage) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            icon_homepage: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 160,
                                height: 80,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 160,
                            height: 80,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.icon_homepage === "string"
                                ? sellerData?.icon_homepage
                                : URL.createObjectURL(sellerData?.icon_homepage)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  icon_homepage: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพไอค่อนหน้าเว็บไซต์"
                          : "Image of icon homepage"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.profile_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            profile_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                  textAlign: "center",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.profile_image === "string"
                                ? sellerData?.profile_image
                                : URL.createObjectURL(sellerData?.profile_image)
                            }
                            alt="profile_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  profile_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพโลโก้ร้านค้า"
                          : "Image of store or logo"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.id_card_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            id_card_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                  textAlign: "center",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.id_card_image === "string"
                                ? sellerData?.id_card_image
                                : URL.createObjectURL(sellerData?.id_card_image)
                            }
                            alt="id_card_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  id_card_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสำเนาใบทะเบียนภาษีมูลค่าเพิ่ม​ (ภ.พ.20) หรือ สำเนาบัตรประชาชน"
                          : "A copy of company registration or ID card"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.warehouse_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            warehouse_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  mr: 1,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                  textAlign: "center",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.warehouse_image === "string"
                                ? sellerData?.warehouse_image
                                : URL.createObjectURL(
                                    sellerData?.warehouse_image,
                                  )
                            }
                            alt="warehouse_image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  warehouse_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพหน้าร้านค้า หรือภาพสินค้าที่เกี่ยวข้องเพื่อยืนยันตัวตน"
                          : "A photo of company, factory or store front in order to verify"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.book_bank_image) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            book_bank_image: files[0],
                          });
                        }}
                        accept=".jpg, .jpeg, .png, .webp"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                  textAlign: "center",
                                }}
                              >
                                อัพโหลดรูปภาพ
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.book_bank_image === "string"
                                ? sellerData?.book_bank_image
                                : URL.createObjectURL(
                                    sellerData?.book_bank_image,
                                  )
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  book_bank_image: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสมุดบัญชี"
                          : "Image of book bank"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.registation) ? (
                      <DropZone
                        onDrop={(files) => {
                          setSellerData({
                            ...sellerData,
                            registation: files[0],
                          });
                        }}
                        accept=".pdf"
                      >
                        {(props) => {
                          return (
                            <ImageEmpty
                              style={{
                                marginLeft: 0,
                                width: 120,
                                height: 120,
                                userSelect: "none",
                                cursor: "pointer",
                                flexDirection: "column",
                              }}
                              {...props}
                            >
                              <PhotoCameraOutlined
                                sx={{
                                  color: "#BCBCC0",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.65rem",
                                  color: "#6C6C70",
                                  textAlign: "center",
                                }}
                              >
                                อัพโหลดเอกสาร
                              </span>
                              <span
                                style={{
                                  fontSize: "0.55rem",
                                  color: "#999",
                                  textAlign: "center",
                                  marginTop: "4px",
                                }}
                              >
                                อัพโหลดเฉพาะไฟล์ PDF เท่านั้น
                              </span>
                            </ImageEmpty>
                          );
                        }}
                      </DropZone>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <TextSnippetIcon
                            sx={{
                              width: "40px",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                              margin: "auto",
                              alignContent: "center",
                              alignItems: "center",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Delete
                              onClick={(e) => {
                                setSellerData({
                                  ...sellerData,
                                  registation: "",
                                });
                              }}
                              sx={{
                                background: "#fff",
                                borderRadius: "100%",
                                color: "#e04132",
                                padding: "3px",
                              }}
                            />
                          </div>
                        </div>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "เอกสารสำเนาเกี่ยวข้องกับร้านค้า"
                          : "Copy of documents related to the store"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>
                </>
              ) : (
                <>
                  <WrapperImageRow>
                    {!sellerData?.icon_homepage ? (
                      <ImageEmpty
                        style={{
                          marginLeft: 0,
                          width: 160,
                          height: 80,
                          userSelect: "none",
                        }}
                      >
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "35%",
                            height: "35%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 160,
                            height: 80,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.icon_homepage === "string"
                                ? sellerData?.icon_homepage
                                : URL.createObjectURL(sellerData?.icon_homepage)
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        {typeof sellerData?.icon_homepage === "string" && (
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={sellerData?.icon_homepage}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        )}
                      </WrapperImage>
                    )}
                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพไอค่อนหน้าเว็บไซต์"
                          : "Image of icon homepage"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.profile_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <img
                          src={sellerData?.profile_image}
                          alt={sellerData?.profile_image}
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "16px",
                            objectFit: "cover",
                          }}
                        />
                        <SpanFullImage
                          onClick={() => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ModalFullImage
                                  image={sellerData?.profile_image}
                                  close={(disp) => closeAllDialogs()}
                                />
                              ),
                            });
                          }}
                        >
                          คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                        </SpanFullImage>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพโลโก้ร้านค้า"
                          : "Image of store or logo"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.id_card_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <img
                          src={sellerData?.id_card_image}
                          alt={sellerData?.id_card_image}
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "16px",
                            objectFit: "cover",
                          }}
                        />
                        <SpanFullImage
                          onClick={() => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ModalFullImage
                                  image={sellerData?.id_card_image}
                                  close={(disp) => closeAllDialogs()}
                                />
                              ),
                            });
                          }}
                        >
                          คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                        </SpanFullImage>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสำเนาใบทะเบียนภาษีมูลค่าเพิ่ม​ (ภ.พ.20) หรือ สำเนาบัตรประชาชน"
                          : "A copy of company registration or ID card"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.warehouse_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <img
                          src={sellerData?.warehouse_image}
                          alt=""
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "16px",
                            objectFit: "cover",
                          }}
                        />
                        <SpanFullImage
                          onClick={() => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ModalFullImage
                                  image={sellerData?.warehouse_image}
                                  close={(disp) => closeAllDialogs()}
                                />
                              ),
                            });
                          }}
                        >
                          คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                        </SpanFullImage>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพหน้าร้านค้า หรือภาพสินค้าที่เกี่ยวข้องเพื่อยืนยันตัวตน"
                          : "A photo of company, factory or store front in order to verify"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.book_bank_image) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <div
                          style={{
                            position: "relative",
                            width: 120,
                            height: 120,
                            borderRadius: "16px",
                            overflow: "hidden",
                            marginBottom: "8px",
                          }}
                        >
                          <img
                            src={
                              typeof sellerData?.book_bank_image === "string"
                                ? sellerData?.book_bank_image
                                : URL.createObjectURL(
                                    sellerData?.book_bank_image,
                                  )
                            }
                            alt="icon homepage"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        {typeof sellerData?.book_bank_image === "string" && (
                          <SpanFullImage
                            onClick={() => {
                              openDialog({
                                type: "custom",
                                customDialog: (
                                  <ModalFullImage
                                    image={sellerData?.book_bank_image}
                                    close={(disp) => closeAllDialogs()}
                                  />
                                ),
                              });
                            }}
                          >
                            คลิกเพิ่มเติมเพื่อดูรูปเต็ม
                          </SpanFullImage>
                        )}
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "รูปภาพสมุดบัญชี"
                          : "Image of book bank"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>

                  <WrapperImageRow>
                    {!checkNotEmpty(sellerData?.registation) ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            width: "25%",
                            height: "25%",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <WrapperImage>
                        <TextSnippetIcon
                          sx={{
                            width: "40px",
                            height: "120px",
                            display: "flex",
                            justifyContent: "center",
                            margin: "auto",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        />
                        <PDownloadPdf
                          onClick={() => {
                            // window.open(`${sellerData?.registation}`, "_blank");
                            downloadImage(`${sellerData?.registation}`, "pdf");
                          }}
                        >
                          Download PDF
                        </PDownloadPdf>
                      </WrapperImage>
                    )}

                    <div>
                      <SpanSubHeader>
                        {getLocale() === "th"
                          ? "รูปภาพเกี่ยวกับคุณ"
                          : "Your Image"}
                      </SpanSubHeader>
                      <SpanContent>
                        {getLocale() === "th"
                          ? "เอกสารสำเนาเกี่ยวข้องกับร้านค้า"
                          : "Copy of documents related to the store"}
                      </SpanContent>
                    </div>
                  </WrapperImageRow>
                </>
              )}

              {/* <StyledButton
                variant="contained"
                onClick={handleUpdateSellerMedia}
              >
                {getLocale() === "th" ? "บันทึก" : "Save"}
              </StyledButton> */}
            </DivBackground>
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ margin: "auto" }}>
            <DivBackground>
              <SpanHeader>
                {getLocale() === "th" ? "รูปภาพอื่นๆ" : "More Image"}
              </SpanHeader>

              {isEdit ? (
                <>
                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.banner_image) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              banner_image: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                    textAlign: "center",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.55rem",
                                    color: "#999",
                                    textAlign: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.banner_image === "string"
                                  ? sellerData?.banner_image
                                  : URL.createObjectURL(
                                      sellerData?.banner_image,
                                    )
                              }
                              alt="banner_image"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    banner_image: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_first) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_first: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                    textAlign: "center",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.55rem",
                                    color: "#999",
                                    textAlign: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_first === "string"
                                  ? sellerData?.work_image_first
                                  : URL.createObjectURL(
                                      sellerData?.work_image_first,
                                    )
                              }
                              alt="work_image_first"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_first: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_second) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_second: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                    textAlign: "center",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.55rem",
                                    color: "#999",
                                    textAlign: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_second ===
                                "string"
                                  ? sellerData?.work_image_second
                                  : URL.createObjectURL(
                                      sellerData?.work_image_second,
                                    )
                              }
                              alt="work_image_second"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_second: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_third) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_third: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                    textAlign: "center",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                                <span
                                  style={{
                                    fontSize: "0.55rem",
                                    color: "#999",
                                    textAlign: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  รองรับไฟล์ JPEG, PNG ไฟล์รูปภาพเท่านั้น
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_third === "string"
                                  ? sellerData?.work_image_third
                                  : URL.createObjectURL(
                                      sellerData?.work_image_third,
                                    )
                              }
                              alt="work_image_third"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_third: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_fourth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_fourth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_fourth ===
                                "string"
                                  ? sellerData?.work_image_fourth
                                  : URL.createObjectURL(
                                      sellerData?.work_image_fourth,
                                    )
                              }
                              alt="work_image_fourth"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_fourth: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_fifth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_fifth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_fifth === "string"
                                  ? sellerData?.work_image_fifth
                                  : URL.createObjectURL(
                                      sellerData?.work_image_fifth,
                                    )
                              }
                              alt="work_image_fifth"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_fifth: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_sixth) ? (
                        <DropZone
                          onDrop={(files) => {
                            setSellerData({
                              ...sellerData,
                              work_image_sixth: files[0],
                            });
                          }}
                          accept=".jpg, .jpeg, .png, .webp"
                        >
                          {(props) => {
                            return (
                              <ImageOtherEmpty
                                style={{
                                  userSelect: "none",
                                  cursor: "pointer",
                                  flexDirection: "column",
                                }}
                                {...props}
                              >
                                <InsertPhotoIcon
                                  sx={{
                                    color: "#BCBCC0",
                                    width: "25%",
                                    height: "25%",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.65rem",
                                    color: "#6C6C70",
                                  }}
                                >
                                  อัพโหลดรูปภาพ
                                </span>
                              </ImageOtherEmpty>
                            );
                          }}
                        </DropZone>
                      ) : (
                        <WrapperOtherImage>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <img
                              src={
                                typeof sellerData?.work_image_sixth === "string"
                                  ? sellerData?.work_image_sixth
                                  : URL.createObjectURL(
                                      sellerData?.work_image_sixth,
                                    )
                              }
                              alt="work_image_sixth"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <Delete
                                onClick={(e) => {
                                  setSellerData({
                                    ...sellerData,
                                    work_image_sixth: "",
                                  });
                                }}
                                sx={{
                                  background: "#fff",
                                  borderRadius: "100%",
                                  color: "#e04132",
                                  padding: "3px",
                                }}
                              />
                            </div>
                          </div>
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.banner_image) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.banner_image}
                            alt={sellerData?.banner_image}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_first) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.work_image_first}
                            alt={sellerData?.work_image_first}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_second) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.work_image_second}
                            alt={sellerData?.work_image_second}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      {!checkNotEmpty(sellerData?.work_image_third) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.work_image_third}
                            alt={sellerData?.work_image_third}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_fourth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.work_image_fourth}
                            alt={sellerData?.work_image_fourth}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_fifth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <>
                          <WrapperOtherImage>
                            <img
                              src={sellerData?.work_image_fifth}
                              alt={sellerData?.work_image_fifth}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "16px",
                                objectFit: "cover",
                              }}
                            />
                          </WrapperOtherImage>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {!checkNotEmpty(sellerData?.work_image_sixth) ? (
                        <ImageOtherEmpty>
                          <InsertPhotoIcon
                            sx={{
                              color: "rgba(0, 0, 0, 0.54)",
                              width: "25%",
                              height: "25%",
                            }}
                          />
                        </ImageOtherEmpty>
                      ) : (
                        <WrapperOtherImage>
                          <img
                            src={sellerData?.work_image_sixth}
                            alt={sellerData?.work_image_sixth}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "16px",
                              objectFit: "cover",
                            }}
                          />
                        </WrapperOtherImage>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </DivBackground>
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={12} sx={{ my: 2 }}>
            <StyledAccordion style={{ borderRadius: "30px" }}>
              <StyledAccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="term-condition-content"
                id="term-condition-header"
              >
                <SpanHeader style={{ margin: 0 }}>
                  สัญญา ข้อกำหนดและเงื่อนไขการเข้าเป็นร้านค้ากับ “Xsurface”
                </SpanHeader>
              </StyledAccordionSummary>

              <AccordionDetails>
                <TermsComponent userData={sellerData} hideHeader={true} />
              </AccordionDetails>
            </StyledAccordion>
          </Grid>
        </Grid>

        {isEdit && (
          <Grid container spacing={4} sx={{ mt: 0, mb: 2 }}>
            <Grid
              item
              xs={6}
              sx={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <StyledButton
                variant="outlined"
                sx={{ minWidth: 110 }}
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการยกเลิกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      setIsEdit(false);
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
              >
                Cancel
              </StyledButton>
              <StyledButton
                variant="contained"
                sx={{ minWidth: 110 }}
                onClick={() => {
                  openDialog({
                    type: "confirm",
                    title: `คุณต้องการบันทึกการแก้ไขใช่หรือไม่`,
                    onConfirm: () => {
                      handleUpdateSeller();
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                }}
              >
                Save
              </StyledButton>
            </Grid>
          </Grid>
        )}

        {/* Reject seller message */}
        {sellerData.is_approve === 2 ? (
          <Grid container spacing={4} sx={{ mt: 0 }}>
            <Grid item xs={12}>
              <SpanReject>
                {getLocale() === "th"
                  ? "เหตุผลการปฎิเสธ"
                  : "Reason to rejected"}
              </SpanReject>
              <SpanContent>
                {sellerData?.reject_seller_message === "" ||
                sellerData?.reject_seller_message === "null" ||
                sellerData?.reject_seller_message === null
                  ? "-"
                  : sellerData?.reject_seller_message}
              </SpanContent>
            </Grid>
          </Grid>
        ) : null}

        {!isEdit && checkAllowPermission("sellers.can_approve") ? (
          sellerData?.is_approve === 0 ? ( // Waiting aprrove new seller
            <Grid container spacing={4} sx={{ mt: 0 }}>
              {sellerData?.is_approve === 0 && isRemark === false ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    margin: "auto",
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <StyledButton
                    variant="contained"
                    sx={{ minWidth: 100 }}
                    onClick={() => {
                      openDialog({
                        type: "confirm",
                        title:
                          getLocale() === "th"
                            ? `ต้องการอนุมัติผู้ขายหรือไม่ ?`
                            : `Want to approve the seller?`,
                        onConfirm: () => {
                          handleSaveApprove();
                        },
                        maxWidth: 342,
                      });
                    }}
                  >
                    Approve
                  </StyledButton>

                  <StyledButton
                    variant="contained"
                    sx={{ minWidth: 100 }}
                    onClick={() => setIsRemark(true)}
                  >
                    Reject
                  </StyledButton>
                </Grid>
              ) : (
                // Add reject reason
                <>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      margin: "auto",
                    }}
                  >
                    <WrapperTextField>
                      <TextField
                        label="เพิ่มเหตุผลการปฎิเสธ"
                        variant="outlined"
                        className="TextField-without-border-radius"
                        sx={{
                          m: 1,
                          width: "98%",
                        }}
                        multiline
                        rows={6}
                        value={comment}
                        onChange={(text) => setComment(text.target.value)}
                      />
                    </WrapperTextField>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      margin: "auto",
                      display: "flex",
                      justifyContent: "end",
                      gap: 2,
                    }}
                  >
                    <StyledButton
                      variant="contained"
                      sx={{ minWidth: 100 }}
                      onClick={() => {
                        setIsRemark(false);
                        setComment("");
                      }}
                    >
                      cancel
                    </StyledButton>

                    <StyledButton
                      variant="contained"
                      sx={{ minWidth: 100 }}
                      onClick={() => {
                        openDialog({
                          type: "confirm",
                          title:
                            getLocale() === "th"
                              ? `ต้องการปฏิเสธผู้ขายหรือไม่ ?`
                              : `Want to reject the seller?`,
                          onConfirm: () => handleSaveReject(),
                          maxWidth: 342,
                        });
                      }}
                    >
                      confirm
                    </StyledButton>
                  </Grid>
                </>
              )}
            </Grid>
          ) : sellerData?.status_update === 1 ? ( // Waiting approve after seller update data
            <Grid container spacing={4} sx={{ mt: 0 }}>
              <Grid
                item
                xs={12}
                sx={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <StyledButton
                  variant="contained"
                  sx={{ minWidth: 100 }}
                  onClick={() => {
                    openDialog({
                      type: "confirm",
                      title:
                        getLocale() === "th"
                          ? `ต้องการอนุมัติผู้ขายหรือไม่ ?`
                          : `Want to approve the seller?`,
                      onConfirm: () => {
                        handleSaveApprove();
                      },
                      maxWidth: 342,
                    });
                  }}
                >
                  Approve
                </StyledButton>
              </Grid>
            </Grid>
          ) : null
        ) : null}
      </Container>
    </Main>
  );
};
export default SellerDetail;
